import React from 'react';
import {Link} from "react-router-dom";

const ToolBar = React.memo(({
                                customClasses,
                                url,
                                navigate,
                                arrowDisplay,
                                title,
                                children
                            }) => {
    return(
        <>
            <div className={`toolbar ${(customClasses ?? "")}`}>
                <div className='container'>
                    <div className='row justify-content-between align-items-center'>
                        <div className='col-auto'>
                            <div className='d-flex align-items-center'>
                                {
                                    url &&
                                    <Link to={url} className={'td-none ml-20 '+arrowDisplay} >
                                        <div className='img-cnt-24'>
                                            <img src={"/assets/images/vectors/arrow_right_black.svg"}/>
                                        </div>
                                    </Link>
                                }
                                {
                                    navigate &&
                                    <div onClick={navigate}
                                        className={'cursor-pointer td-none ml-20 '+arrowDisplay} >
                                        <div className='img-cnt-24'>
                                            <img src={"/assets/images/vectors/arrow_right_black.svg"}/>
                                        </div>
                                    </div>
                                }
                                <div className='mobile-h3 cl-black'>
                                    { title }
                                </div>
                            </div>
                        </div>
                        <div className='col-auto'>
                            { children }
                        </div>
                    </div>
                </div>
            </div>
            <div className='top-offset-1'/>
        </>
    )
})


export default ToolBar